// extracted by mini-css-extract-plugin
export var bar = "style-mod--bar--b97c1";
export var content = "style-mod--content--4bf38";
export var divider = "style-mod--divider--31458";
export var hiddenBestsellers = "style-mod--hidden-bestsellers--01e00";
export var img = "style-mod--img--ac2c5";
export var urlBox = "style-mod--url-box--22fff";